import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function UpsellIcon(props: IconProps) {
  return (
    <Icon width="72" height="73" viewBox="0 0 72 73" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="36" cy="36.8071" r="36" fill="white" />
      <path
        d="M52.5428 27.2936C54.716 31.0576 55.5386 35.451 54.8745 39.7463C54.2103 44.0417 52.0993 47.9814 48.8908 50.9134C45.6823 53.8454 41.5687 55.5938 37.2311 55.8692C32.8934 56.1445 28.5918 54.9304 25.0383 52.4277"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
      <path
        d="M19.457 46.3226C17.2838 42.5586 16.4612 38.1652 17.1253 33.8699C17.7894 29.5745 19.9005 25.6348 23.109 22.7028C26.3175 19.7708 30.431 18.0224 34.7687 17.747C39.1063 17.4717 43.408 18.6858 46.9615 21.1886"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
      <path
        d="M57.8159 29.0066L52.517 26.3603L49.8712 31.6595"
        stroke="#191A1C"
        strokeWidth="1.2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M14.0525 44.6096L19.3515 47.2559L21.9973 41.9567"
        stroke="#191A1C"
        strokeWidth="1.2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M40.0824 31.372C40.0824 33.5986 38.2775 35.4035 36.051 35.4035C33.8245 35.4035 32.0196 33.5986 32.0196 31.372C32.0196 29.1455 33.8245 27.3406 36.051 27.3406C38.2775 27.3406 40.0824 29.1455 40.0824 31.372Z"
        fill="#57D7FF"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
      <path
        d="M44.694 46.2083H27.4092C27.7173 41.7038 31.4689 38.1454 36.0516 38.1454C40.6343 38.1454 44.3859 41.7038 44.694 46.2083Z"
        fill="#57D7FF"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
    </Icon>
  );
}
